/* eslint-disable @typescript-eslint/no-non-null-assertion */

/** Возвращает отсортированный по maxWidth/minWidth  массив настроек карты */
export var sortMedia = function sortMedia(media) {
  var i = 0;

  /* Сортировка настроек */
  var currentMedia = media.sort(function (a, b) {
    /* Кидаем ошибку если минимальная ширина больше максимальной или на оборот */
    if (a.minWidth > a.maxWidth) {
      throw new Error("\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0448\u0438\u0440\u0438\u043D\u0430 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 media #".concat(i, " \u0431\u043E\u043B\u044C\u0448\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439"));
    } else if (b.minWidth > b.maxWidth) {
      throw new Error("\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0448\u0438\u0440\u0438\u043D\u0430 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 media #".concat(i + 1, " \u0431\u043E\u043B\u044C\u0448\u0435 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0439"));
    }
    i++;
    if (a.maxWidth > b.minWidth) {
      return 1;
    }
    if (a.maxWidth < b.minWidth) {
      return -1;
    }
    return 0;
  });

  /* Валидация выбранных настроек */
  currentMedia.forEach(function (a, i, array) {
    if (i === array.length - 1) {
      return;
    }
    var b = array[i + 1];

    /* Кидаем ошибку если максимальная ширина больше минмальной ширины следующего элемента */
    if (a.maxWidth > b.minWidth) {
      throw new Error("\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0448\u0438\u0440\u0438\u043D\u0430 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 media #".concat(i, " \u0431\u043E\u043B\u044C\u0448\u0435 \u043C\u0438\u043D\u043C\u0430\u043B\u044C\u043D\u043E\u0439 \u0448\u0438\u0440\u0438\u043D\u044B \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 media #").concat(i + 1));
    } else if (isNaN(a.minWidth) || isNaN(a.maxWidth) || isNaN(b.minWidth) || isNaN(b.maxWidth)) {
      throw new Error("\u041E\u0434\u043D\u0430 \u0448\u0438\u0440\u0438\u043D\u0430 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 media \u0440\u0430\u0432\u043D\u0430 NaN");
    }
  });

  /* Кидаем ошибку если превый minWidth или последний maxWidth не бесконечность */
  if (media[0].minWidth !== -Infinity || media[media.length - 1].maxWidth !== Infinity) {
    throw new Error("\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0448\u0438\u0440\u0438\u043D\u0430 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u0438 \u043C\u0430\u043A\u0441\u0438\u043C\u043B\u044C\u043D\u0430\u044F \u0448\u0438\u0440\u0438\u043D\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u0430 \u043C\u0430\u0441\u0441\u0438\u0432\u0430 media \u0434\u043E\u043B\u0436\u043D\u044B \u0431\u044B\u0442\u044C -Infinity \u0438 +Infinity");
  }
  return currentMedia;
};

/** Возвращает объект настроек карты в зависимости от ширины экрана */
export var getCurrentMedia = function getCurrentMedia(media) {
  return media.find(function (_ref) {
    var minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth;
    var min = minWidth === -Infinity ? 0 : minWidth;
    var max = maxWidth === Infinity ? 99999 : maxWidth;
    return window.matchMedia("(min-width: ".concat(min, "px) and (max-width: ").concat(max, "px)")).matches;
  });
};